import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

const List = ({ list, onCheck, href, headings, loading, actions, actionTitle, checkBoxes = true, footerContent, hideHeading = false, CustomHeader, gridTemplateColumns }) => {
    const [checks, setChecks] = useState(Array.apply(null, Array(list?.length)).map(() => false))
    const [allChecked, setAllChecked] = useState(false);
    const [detailsPanel, setDetailsPanel] = useState({row: -1, cell: -1});
    const [detailsStatus, setDetailsStatus] = useState('closed');
    const timeoutRef = useRef(null);
    const checkAll = (e) => {
        setChecks(checks.map(() => !allChecked));
        setAllChecked(!allChecked);
        onCheck(checks.map(() => !allChecked))
    }
    const checked = (index) => {
        var newC = [...checks];
        newC[index] = !newC[index];
        var allTrue = true;
        for (var i = 0; i < newC.length; i++) {
            if (newC[i] === false) {
                allTrue = false;
                break;
            }
        }
        if (allTrue) {
            setAllChecked(true);
        } else {
            setAllChecked(false);
        }
        setChecks(newC);
        onCheck(newC);
    }
    useEffect(() => {
        setChecks(Array.apply(null, Array(list?.length)).map(() => false))
    }, [list]);
    if (!headings?.length)
        return null;
    return (
        <div className={`item-list grid grid-${headings.filter(a => !a.hide).length + Math.min(actions?.length || 0, 1) - (checkBoxes ? 0 : 1)}`} style={gridTemplateColumns ? {gridTemplateColumns} : undefined}>
            {!hideHeading && (CustomHeader ? <CustomHeader /> : (
                <div className="grid-row grid-title">
                    {checkBoxes && (
                        <div className="grid-cell">
                            <input type="checkbox" checked={allChecked} aria-label="Check All" onChange={checkAll} />
                        </div>
                    )}
                    {headings.filter(a => !a.hide).map((h, i) => {
                        return (
                            <div key={i} className={`grid-cell${h.center ? ' grid-center' : ''}`}>
                                {h.name}
                            </div>
                        )
                    })}
                    {!!actions?.length && <div className="grid-cell grid-action-cell">{actionTitle}</div>}
                </div>
            ))}
            {loading && (
                <div className="grid-row">
                    <div className="grid-cell full-grid">
                        <div className="loading" style={{color: '#AAA5BF'}}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            )}
            {(list.length === 0 && !loading) && (
                <div className="grid-row">
                    <div className="grid-cell full-grid">
                        No Results
                    </div>
                </div>
            )}
            {list.map((l, i) => {
                const row = i;
                return (
                    <div key={i} className="grid-row">
                        {checkBoxes && (
                            <div className="grid-cell">
                                <input type="checkbox" checked={checks[i]} onChange={() => checked(i)} aria-label={"Check Row #" + i} />
                            </div>
                        )}
                        {headings.filter(a => !a.hide).map((h, j) => {
                            const cell = j;
                            if (h.Component) {
                                var params = {};
                                h.key.forEach(k => {
                                    params[k] = l[k];
                                });

                                if (h.detailsIcon) {
                                    const isActive = detailsPanel.row == row && detailsPanel.cell == cell;
                                    return (
                                        <div key={j} onClick={() => {
                                            if (detailsStatus == 'closed') {
                                                setDetailsStatus('open');
                                                setDetailsPanel({
                                                    row: row,
                                                    cell: cell,
                                                    Component: () => <h.Component {...params} />
                                                });
                                                return;
                                            }
                                            if (detailsStatus == 'open' && isActive) {
                                                setDetailsStatus('closing');
                                                timeoutRef.current = setTimeout(() => {
                                                    setDetailsStatus('closed');
                                                    setDetailsPanel({
                                                        row: -1,
                                                        cell: -1
                                                    });
                                                }, 200);
                                                return;
                                            }
                                            if (timeoutRef.current) {
                                                clearTimeout(timeoutRef.current);
                                                timeoutRef.current = null;
                                            }
                                            setDetailsStatus('closing');
                                            timeoutRef.current = setTimeout(() => {
                                                setDetailsStatus('open');
                                                setDetailsPanel({
                                                    row: row,
                                                    cell: cell,
                                                    Component: () => <h.Component {...params} />
                                                });
                                            }, 200);
                                        }} className={`grid-details grid-cell${h.center ? ' grid-center' : ''}`}>
                                            <h.detailsIcon active={isActive} />
                                        </div>
                                    )
                                }

                                return (
                                    <div key={j} className={`grid-cell${h.center ? ' grid-center' : ''}`}>
                                        {h.link ? (
                                            <Link to={'/' + href} state={{ id: l[h.linkKey]}}>
                                                <h.Component {...params} />
                                            </Link>
                                        ) : (
                                            <h.Component {...params} />
                                        )}
                                    </div>
                                );
                            }
                            var v = l[h.key];
                            return (
                                <div key={j} className={`grid-cell${h.center ? ' grid-center' : ''}`}>
                                    {h.link ? (
                                        <Link to={'/' + href} state={{ id: l[h.linkKey]}}>{h.image && v ? <img className="item-image" src={process.env.REACT_APP_MEDIA_URL + v} alt={v} /> : v}</Link>
                                    ) : (
                                        h.image && v ? <img className="item-image" style={h.onClick ? {cursor: 'pointer'} : undefined} onClick={() => h.onClick && h.onClick(l[h.linkKey])} src={process.env.REACT_APP_MEDIA_URL + v} alt={v} /> : <span style={h.onClick ? {cursor: 'pointer'} : undefined} onClick={() => h.onClick && h.onClick(l[h.linkKey])}>{v?.map ? v.map((_v, _i) => <div key={_i}>{ _v }</div>) : v }</span>
                                    )}
                                </div>
                            );
                        })}
                        {!!actions?.filter(a => !a?.hide?.(l))?.length ? (
                            <div className="p-rel grid-action-cell">
                                <div tabIndex={0} className="grid-actions">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.99967 8.66732C8.36786 8.66732 8.66634 8.36884 8.66634 8.00065C8.66634 7.63246 8.36786 7.33398 7.99967 7.33398C7.63148 7.33398 7.33301 7.63246 7.33301 8.00065C7.33301 8.36884 7.63148 8.66732 7.99967 8.66732Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.99967 3.99935C8.36786 3.99935 8.66634 3.70087 8.66634 3.33268C8.66634 2.96449 8.36786 2.66602 7.99967 2.66602C7.63148 2.66602 7.33301 2.96449 7.33301 3.33268C7.33301 3.70087 7.63148 3.99935 7.99967 3.99935Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.99967 13.3333C8.36786 13.3333 8.66634 13.0349 8.66634 12.6667C8.66634 12.2985 8.36786 12 7.99967 12C7.63148 12 7.33301 12.2985 7.33301 12.6667C7.33301 13.0349 7.63148 13.3333 7.99967 13.3333Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <div className="actions-list">
                                        {actions.filter(a => !a?.hide?.(l)).map((a, z) => (
                                            <a key={z} role="button" onClick={(e) => {
                                                a.action(l);
                                                e.target.parentElement.parentElement.blur();
                                            }}>
                                                {a.text(l)}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : actions?.length > 0 ? <div className="grid-action-cell p-rel"></div> : null}
                        <div className={`grid-details-view ${detailsPanel.row == row ? ' ' + detailsStatus : ''}`}>
                            {!!detailsPanel.Component && <div><detailsPanel.Component /></div>}
                        </div>
                    </div>
                );
            })}
            {!!footerContent && (
                <div className="grid-footer">
                    <div className="grid-cell full-grid">
                        {footerContent}
                    </div>
                </div>
            )}
        </div>
    )
}

export default List;